import React, { useEffect, useState } from "react";
import _fetch from "../config/api";
import { logo, title } from "../config/Config";
import Confirmation_gif from "../Assets/Icon/email-Confirmation.gif";
import { useLocation } from "react-router-dom";
import { api_url, titleDescription, website } from "../config/Config";

const WaitingScreen = (props: any) => {
  const location = useLocation();
  const details = location.state;
  const [userData, setUserData] = useState({});
  const [userDetails, setUserDetails] = useState<{
    username: string;
    trxpassword: string | number;
    Originalpassword: string;
    user_info: {
      name: string;
    };
  }>({
    username: "",
    trxpassword: "",
    Originalpassword: "",
    user_info: {
      name: "",
    },
  });
  useEffect(() => {
    const data = localStorage.getItem("user");
    if (data) {
      try {
        const parsedData = JSON.parse(data);
        setUserDetails(parsedData);
      } catch (error) {
        console.error("Error parsing user data:", error);
      }
    }
  }, []);

  return (
    <div>
      <div className="data_as">
        <div className="data___outer">
          <div className="form__ssd">
            <div className="for-logo">
              <img src={logo} alt="" className="logo-imgage-f" />
            </div>
       
            <img
              height="170px"
              className="data__email_img"
              src={Confirmation_gif}
              alt="Confirmation-gif"
            />
            {/* <h2>Verify Your Email for Account Access</h2> */}
            <h1 className="name___user mb-3">Registration Successful</h1>
            <p>
              Dear {userDetails?.user_info?.name}, Your Account Has Been
              Successfully Created
            </p>

            <div className="succes-detail">
              <h5 className="for-value">
                <span>User Name </span>: <span>{userDetails?.username} </span>
                </h5>
              <h5 className="for-value" ><span>Password</span>: <span>{userDetails?.Originalpassword}</span></h5>
              <h5 className="for-value" ><span>Transaction Password</span>: <span>{userDetails?.trxpassword}</span></h5>
            </div>
            <div className="btn-logins">
              <a href="/login">Click Here to Login</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WaitingScreen;
